; (function () {


    var showResourceAvailabilityRoutes = [
        {
            name: "Show_Resource_Availability",
            templateUrl: "<div emr-appointment-scheduler-show-resource-availability-and-select-popup></div>",
            RoutingNumber: 4010,
            directivescontrollersFiles: "directiveFiles",
            files: [
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
                "AngularScripts/ShowResourceAvailabilityAndSelect/Services/ShowResourceAvailabilityAndSelectService.js",
                "AngularScripts/ShowResourceAvailabilityAndSelect/Directives/AppointmentSchedulerShowResourceAvailabilityAndSelectPopupDirective.js"
            ]
        }
    ]



    angular.module('EMR.ShowResourceAvailabilityAndSelect',[])
        .config(["$stateProvider", "EmrRouteProvider", 
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(showResourceAvailabilityRoutes, $stateProvider);
            }]);


})();